import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/GRR.png";

export const greatestRoyalRumbleDetail = {
  "greatest-royal-rumble": {
    id: "greatest-royal-rumble",
    title: "Greatest Royal Rumble",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "greatest-royal-rumble",
        items: [
          {
            id: "greatest-royal-rumble-1",
            title: "Greatest Royal Rumble",
            description: "Hosted in the kingdom of Saudi Arabia 2018",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
